
import ScrollBooster from "scrollbooster";

export const DRAGGABLE_SCROLL = {
  init: () => {
    new ScrollBooster({
      viewport: document.querySelector('.sec-map .map-wrap'),
      scrollMode: 'native'
    });
  }
};